import $http from "../../axios";
import { Notification } from "element-ui";

export async function fetchConsignmentProductsPreInvoice({ state, commit }) {
    try {
        const response = await $http.get(
            `/api/informe-prefactura-prods-en-consignacion`,
            {
                params: state.paramsReport
            }
        );

        commit("setConsignmentProductsPreInvoiceData", response.data);
    } catch (error) {
        console.error("Error fetching tax liquidator config:", error.message);
        throw error;
    }
}

export function fetchConsignmentProductsPreInvoiceByProductId(
    { state },
    product_id
) {
    return new Promise((resolve, reject) => {
        $http
            .get(`/api/informe-prefactura-prods-en-consignacion-por-producto`, {
                params: {
                    ...state.paramsReport,
                    product_id
                }
            })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                console.error(
                    "Error fetching consignment products:",
                    error.message
                );
                reject(error);
            });
    });
}



// WEBPACK FOOTER //
// ./src/modules/consignment-products-pre-Invoice/actions.js